import React from 'react';
import InvoicePage from '../components/InvoicePage';

const InvoicePageContainer = () => {
  return <InvoicePage />;
};

export default InvoicePageContainer;
